import {
  FETCH_BANNER,
  FETCH_BANNERS,
  FETCH_USER,
  FETCH_RETAILERS,
  FETCH_ADVERTISERS,
  FETCH_RETAILER,
  FETCH_ADNUMBER,
  FETCH_ADVERTISER,
  FETCH_BANNER_TYPE,
  FETCH_CURRENTADVERTISER,
  FETCH_BANNER_ID,
  FETCH_TEMPLATES,
  FETCH_TEMPLATE,
  OPEN_MODAL,
  CLOSE_MODAL,
  SET_DIV_CLASS,
  CLEAR_SEARCH,
  FETCH_PAGE,
  FETCH_ERROR,
  CLEAR_ERROR,
  FASTRADE,
  FETCH_ORDERS,
  FETCH_LINE_ITEMS,
  FETCH_AD_DATA,
  CLEAR_AD_DATA,
  FETCH_AD_REQUEST,
  FETCH_SEARCH_RESULTS,
  FETCH_SKU_SEARCH,
  CLEAR_SKU_SEARCH,
  FETCH_RANGE_SEARCH,
  CLEAR_RANGE_SEARCH,
  FETCH_PRODUCT_IMAGE,
  SIZE_TO_FIT,
} from "./types";

export const fetchBanner = (data) => {
  const banner = data || {};
  return {
    type: FETCH_BANNER,
    payload: banner,
  };
};

export const fetchBanners = (banners) => {
  return {
    type: FETCH_BANNERS,
    payload: banners,
  };
};

export const fetchRetailers = (retailers) => {
  return {
    type: FETCH_RETAILERS,
    payload: retailers,
  };
};

export const fetchUser = (user) => {
  user = user || null;
  return {
    type: FETCH_USER,
    payload: user,
  };
};

export const fetchAdvertisers = (advertisers) => {
  return {
    type: FETCH_ADVERTISERS,
    payload: advertisers,
  };
};

export const fetchAdvertiser = (advertiser) => {
  return {
    type: FETCH_ADVERTISER,
    payload: advertiser,
  };
};

export const fetchBannerType = (bannerType) => {
  return {
    type: FETCH_BANNER_TYPE,
    payload: bannerType,
  };
};

export const fetchCurrentAdvertiser = (advertiser) => {
  return {
    type: FETCH_CURRENTADVERTISER,
    payload: advertiser,
  };
};

export const fetchAdnumber = (adnumber) => {
  return {
    type: FETCH_ADNUMBER,
    payload: adnumber,
  };
};

export const fetchBannerId = (id) => {
  return {
    type: FETCH_BANNER_ID,
    payload: id,
  };
};

export const fetchRetailer = (retailer) => {
  return {
    type: FETCH_RETAILER,
    payload: retailer,
  };
};

export const openModal = (modalType, modalProps) => {
  return {
    type: OPEN_MODAL,
    payload: { modalType, modalProps },
  };
};

export const closeModal = () => {
  return {
    type: CLOSE_MODAL,
  };
};

export const setDivClass = (divClass) => {
  return {
    type: SET_DIV_CLASS,
    payload: divClass,
  };
};

export const clearSearch = () => {
  return {
    type: CLEAR_SEARCH,
  };
};

export const fetchPage = (page) => {
  return {
    type: FETCH_PAGE,
    payload: page,
  };
};

export const fetchError = (error) => {
  return {
    type: FETCH_ERROR,
    payload: error,
  };
};

export const clearError = () => {
  return {
    type: CLEAR_ERROR,
  };
};

export const fetchTemplates = (templates) => {
  return {
    type: FETCH_TEMPLATES,
    payload: templates,
  };
};

export const fetchTemplate = (template) => {
  return {
    type: FETCH_TEMPLATE,
    payload: template,
  };
};

export const showHideFastrade = (data) => {
  return {
    type: FASTRADE,
    payload: data,
  };
};

export const fetchOrders = (data) => {
  return {
    type: FETCH_ORDERS,
    payload: data,
  };
};

export const fetchLineItems = (data) => {
  return {
    type: FETCH_LINE_ITEMS,
    payload: data,
  };
};

export const fetchAdData = (data) => {
  return {
    type: FETCH_AD_DATA,
    payload: data,
  };
};

export const clearAdData = () => {
  return {
    type: CLEAR_AD_DATA,
  };
};

export const fetchAdRequest = (data) => {
  return {
    type: FETCH_AD_REQUEST,
    payload: data,
  };
};

export const fetchSearchResults = (data) => {
  return {
    type: FETCH_SEARCH_RESULTS,
    payload: data,
  };
};

export const fetchSkuSearch = (data) => {
  return {
    type: FETCH_SKU_SEARCH,
    payload: data,
  };
};

export const clearSkuSearch = (data) => {
  return {
    type: CLEAR_SKU_SEARCH,
  };
};

export const fetchRangeSearch = (data) => {
  return {
    type: FETCH_RANGE_SEARCH,
    payload: data,
  };
};

export const clearRangeSearch = (data) => {
  return {
    type: CLEAR_RANGE_SEARCH,
  };
};

export const fetchProductImage = (data) => {
  return {
    type: FETCH_PRODUCT_IMAGE,
    payload: data,
  };
};

export const sizeToFit = (checked) => {
  return {
    type: SIZE_TO_FIT,
    payload: checked,
  };
};
